import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fuel-level-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fuel-level-display.component.html',
  styleUrl: './fuel-level-display.component.scss'
})
export class FuelLevelDisplayComponent {
  @Input() level: number | null;
  @Input() threshold: number | null;

  getClass(): string {
    if (this.level == null || this.threshold == null || this.level >= this.threshold) {
      return '';
    }

    return 'warning';
  }
}
